import { action, makeObservable, observable } from "mobx";
import { privatePost } from "../utils/NetworkService";


export class CoinExchangeStore {
  rootStore;


  isBTCOpen = true;
  isUSTDOpen = false;

  userID = "";
  userName = "";
  userCountBTC = "";
  userAddress = "";
  userBank = "";
  userPlatform = "MATIC";



  constructor(root) {
    makeObservable(this, {
      isBTCOpen: observable,
      isUSTDOpen: observable,
      userID: observable,
      userName: observable,
      userCountBTC: observable,
      userAddress: observable,
      userPlatform: observable,
      userBank: observable,




      setAllValueChack: action,
      getUserBank: action,
      setExchangeData: action,
      getUserAddress: action,
      getUserBTC: action,
      getUserName: action,
      getUserID: action,
      setUSTDOpen: action,
      setBTCOpen: action,
    });

    this.rootStore = root;


    this.isBTCOpen = true;
    this.isUSTDOpen = false;

    this.userID = "";
    this.userName = "";
    this.userCountBTC = "";
    this.userAddress = "";
    this.userBank = "";
    this.userPlatform = "MATIC";




  }

  setBTCOpen(isOpen) {
    this.setAllValueChack();
    if (isOpen === true || this.isBTCOpen === true) {
      this.isUSTDOpen = false;
    }
    this.isBTCOpen = isOpen;
    this.userPlatform = "BTC";
  }

  setUSTDOpen(isOpen) {
    this.setAllValueChack();
    if (isOpen === true || this.isUSTDOpen === true) {
      this.isBTCOpen = false;
    }
    this.isUSTDOpen = isOpen;
    this.userPlatform = "USTD";
  }

  getUserID(value) {
    // console.log("ID", value);
    this.userID = value;
  }

  getUserName(value) {
    // console.log("Name", value);
    this.userName = value;
  }

  getUserBTC(value) {
    // console.log("BTC", value);
    this.userCountBTC = value;

  }

  getUserAddress(value) {
    // console.log("Address", value);
    this.userAddress = value;
  }

  getUserBank(value) {
    this.userBank = value;
  }

  setAllValueChack() {
    this.userID = "";
    this.userName = "";
    this.userCountBTC = "";
    this.userAddress = "";
    this.userBank = "";

  }



  setExchangeData(value) {


    const api = "/UserExchangeCoin";

    let data = {
      member_no: parseInt(this.rootStore?.loginStore?.loginState?.member_no),
      user_id: String(this.userID),
      user_name: String(this.userName),
      user_count: parseFloat(this.userCountBTC),
      user_address: String(this.userAddress),
      user_platform: String(this.userPlatform),
      user_bank: String(this.userBank),
    }


    if (data?.user_id !== "" && data?.user_name !== "" && data?.user_count !== "" && this.userCountBTC !== "" && data?.user_address !== "" && data?.user_platform !== "") {


      privatePost({ api: api, data: data }, (err, response) => {
        if (err) {
          // console.log(err);
          // if (err.errorCode === 3804) {
          //   // this.grade_error_clover_db_send = this.rootStore?.loginStore?.ErrorGuide_clover_005;
          return alert(this.rootStore?.loginStore?.ErrorGuide_501);//잠시후 다시 시도해주세요.
          // }
          // else {
          //   // return alert(this.rootStore?.loginStore?.GuideCheck_clover_coinStore_message_02);//취소되었습니다
          // }
        } else {
          this.setAllValueChack();
          // console.log(response?.data?.result);
          // this.setProductitem(response?.data?.result );
        }
      });
    }
    else {
      if (data?.user_id === "") {
        alert("아이디를 입력해 주세요");
      }
      else if (data?.user_name === "") {
        alert("Name을 입력해 주세요");
      }
      else if (this.userCountBTC === "") {
        alert("수량을 입력해 주세요");
      }
      else if (data?.user_bank === "") {
        alert("은행을 입력해 주세요");
      }
      else if (data?.user_address === "") {
        alert("계좌번호를 입력해 주세요");
      }
    }


  }




}